import { HelpContent } from './siteAccessPolicies';

export const chargingPartnersHelp = {
    "/share/business/charging-partners/map": {
        overview: "This interactive map shows your charging network, including partner locations, business sites, and potential charging opportunities.",
        sections: [
            {
                title: "Map Features",
                content: [
                    "Network Locations: Green markers show approved charging partner locations",
                    "Business Sites: Blue building icons show your business locations",
                    "Potential Partners: Grey markers show potential charging partners",
                    "In Progress Sites: Markers for charging locations being developed",
                    "Service Areas: Colored polygons show charging network coverage areas"
                ]
            },
            {
                title: "Filtering Options",
                content: [
                    "Show/Hide Network: Toggle visibility of approved charging partner locations",
                    "Show/Hide Business: Toggle visibility of your business locations",
                    "Show/Hide Potential Partners: Toggle visibility of potential charging partners",
                    "Show/Hide In Progress Sites: Toggle visibility of sites under development",
                    "Show/Hide Polygons: Toggle visibility of service area polygons",
                    "Workflow State vs Business Name: Switch between showing workflow status or business names in tooltips"
                ]
            },
            {
                title: "Charging Detour Filter",
                content: [
                    "Use the slider to filter charging locations by detour distance",
                    "Range from 0 to 100 km - adjust to see locations within your preferred detour range",
                    "This helps identify charging opportunities that don't require significant route changes"
                ]
            },
            {
                title: "Interaction",
                content: [
                    "Hover over markers: View business names or workflow states in tooltips",
                    "Zoom and pan: Navigate the map to explore different areas",
                    "Mobile view: Use checkboxes instead of buttons for filtering on mobile devices"
                ]
            },
            {
                title: "Quick Actions",
                content: [
                    "Charging Partners: View and manage your charging partner relationships",
                    "Transactions: Monitor charging transactions and usage",
                    "Configuration: Configure network settings and parameters"
                ]
            }
        ]
    } as HelpContent,

    "/share/business/charging-partners": {
        overview: "Manage your charging partnerships and explore potential collaborations with other businesses in the EV charging network.",
        sections: [
            {
                title: "Filter Options",
                content: [
                    "All: View all charging partners regardless of status",
                    "Agreed: Show only partners with active agreements",
                    "Offered: Show partners where offers have been made or received",
                    "Requested: Show partners where partnership requests are pending"
                ]
            },
            {
                title: "Workflow States",
                content: [
                    "POTENTIAL: Partner available for partnership - click to request",
                    "REQUESTED: Partnership request sent - waiting for response",
                    "OFFERED: Offer received (red dot) - click to review and respond",
                    "AGREED: Partnership active (green checkmark) - click to view details"
                ]
            },
            {
                title: "Partner Categories",
                content: [
                    "Charging Station Icon: Partner provides charging infrastructure",
                    "Truck Icon: Partner has charging needs (fleet vehicles)",
                    "Both Icons: Partner both provides and needs charging",
                    "Star Icon: Recommended partner based on your needs"
                ]
            },
            {
                title: "Actions Available",
                content: [
                    "Click Partner Name: View detailed partner information",
                    "Click Workflow State: Take action based on current status",
                    "Request Partnership: Send partnership request to potential partners",
                    "Review Offers: Respond to partnership offers from other businesses",
                    "View Agreement Details: Access full partnership information"
                ]
            },
            {
                title: "Partnership Process",
                content: [
                    "1. Discovery: Browse potential partners in the network",
                    "2. Request: Send partnership request to interested parties",
                    "3. Negotiation: Review and respond to offers received",
                    "4. Agreement: Finalize partnership terms and activate",
                    "5. Management: Monitor and manage active partnerships"
                ]
            }
        ]
    } as HelpContent
}; 